import { sqliteTable, text, real } from "drizzle-orm/sqlite-core";
import { rentalReturns } from "./rental-returns";

// ============================================================================
// rental_penalties — ค่าปรับ (child of rental_returns)
// ============================================================================
export const rentalPenalties = sqliteTable("car_rental_rental_penalties", {
  id: text("id").primaryKey(), // ULID
  returnId: text("return_id").notNull().references(() => rentalReturns.id), // FK → rental_returns
  description: text("description"),
  amount: real("amount").notNull().default(0),
  remarks: text("remarks"),
  // Immutable — no update/delete fields
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
});

export type RentalPenalty = typeof rentalPenalties.$inferSelect;
export type NewRentalPenalty = typeof rentalPenalties.$inferInsert;
